import React, { useState, useEffect,  useRef } from "react";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";
import "./style.scss";
import { GlobalState } from "contexts/GlobalState";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import CustomPlaceHolder from "./components/CustomPlaceHolder";
import { GET_PROGRAMS } from "schemas/program";
import searchIcon from "assets/img/black-magnifying-glass.png";
import searchProgramsIcon from "assets/img/vector-smart-object-3-copy.png";

export default function SearchBar(props) {
  const [globalSearch, setGlobalSearch] = GlobalState("search");
  const [resultsLoading, setResultsLoading] = useState(false);
  const [options, setOptions] = useState([])
  const searchValue = Utils.getQueryStringValue("mainSearch");
  const elementRef = useRef();

  const searchUrl = window.location.href.includes("search");

  const [getPrograms, { loading: programLoading, data: programData }] = useLazyQuery(GET_PROGRAMS, {
    fetchPolicy: "no-cache",
  });
  
  function setClassNmaeByPage() {
    if (window.location.href.includes("search"))
      return "search-programs-img";
    if (window.location.href.includes("profile"))
      return "profile-img";
    else return "search-img"
  }

  function setGlobalMainSearch(searchValue, shouldUpdateResults) {
    let searchFilters = {
      ...globalSearch.filters,
      mainSearch: searchValue,
      isSearch: shouldUpdateResults
    };
    let searchFiltersNoDegree = {...searchFilters};
    searchFiltersNoDegree.degree && delete searchFiltersNoDegree.degree ;
    if (shouldUpdateResults) {
      setGlobalSearch({
        ...globalSearch,
        filters: searchFiltersNoDegree,
        loading: true
      });
    } else {
      setGlobalSearch({
        ...globalSearch,
        filters: searchFilters,
        loading: true  
      });
    }
    globalSearch.query({
      variables: {
        search: searchFiltersNoDegree,
      },
    });
  }

  const searchLocally = (searchValue) => {
    let searchFilters = {
      ...globalSearch.filters,
      mainSearch: searchValue,
    }
    getPrograms({
      variables: {
        search: searchFilters
      }
    })
  }

  const handleSearch = (searchValue) => {
    setResultsLoading(true);
    searchLocally(searchValue);
  };

  const handleChange = (value) => {
    const shouldUpdateResults = value == undefined ? false : true;
    const inputValue = document.querySelector(".rbt-input-main").value;
    setGlobalMainSearch(inputValue, shouldUpdateResults);
    const qs = Utils.setQueryStringValue("mainSearch", inputValue);
    if (props.labels.is_homepage || props.is_profile_page) {
      const url = `/he/search-program${qs}`;
      location.assign(url);
    } else {
      Utils.setQueryStringWithoutPageReload(qs);
    }
    setGlobalMainSearch(inputValue, shouldUpdateResults);
  };

  const handleFocus = () => {
    if (!props?.placeholder) {
      document.getElementsByClassName("search-placeholder")[0].style.display = "none";
    }
  };

  const handleClickCustomPlaceholder = () => {
    handleFocus();
    document.getElementsByClassName("rbt-input-main form-control rbt-input")[0].focus();
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleChange([e.target.value]);
      elementRef.current.blur();
    }
  };

  const findOptions = () => {
    let newOptions = []
    if(programData) {
      programData?.getPrograms?.results?.forEach(result => {
        newOptions.push(result.title);
        result.field_short_name?.map(shortName=>{
          if(!newOptions.includes(shortName))
            newOptions.push(shortName);
      })
      });
      newOptions = _.uniq(newOptions);
      setOptions(newOptions);
    } else {
    setOptions([{ label: "", value: "" }]);
    }
  }

  //add query params to filters
  useEffect(() => {
    if (searchValue) {
      setGlobalMainSearch(searchValue);
    }
  }, []);
  //when we received new results in getPrograms, enter findOptions
  useEffect(() => {
    if(programData && !programLoading) {
      findOptions();
    }
  },[globalSearch, programData]);

  //when we loaded the new options set isLoading to false
  useEffect(() => {
    setResultsLoading(false);
  },[options]);

  const filterBy = () => true;

  return (
    <div className="search-bar">
      {!props?.placeholder && (
        <div className="search-placeholder" onClick={handleClickCustomPlaceholder}>
          <CustomPlaceHolder labels={props.labels}></CustomPlaceHolder>
        </div>
      )}
      <div className="vertical-line"/>
      <img 
      src={searchUrl ? searchProgramsIcon: searchIcon}
      className={setClassNmaeByPage()}
      onClick={() =>handleChange(true)}
      alt="search"
      />
      <AsyncTypeahead
        ref={elementRef}
        inputProps={{
          'aria-label': props.labels.title,
        }}
        filterBy={filterBy}
        id={"at1"}
        onFocus={handleFocus}
        isLoading={resultsLoading}
        onSearch={handleSearch}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        defaultInputValue={searchValue}
        options={options}
        placeholder={window.location.pathname=='/he/search-global'?props.labels.placeholder_search:props.placeholder}
        minLength={2}
        emptyLabel={props.labels.no_results}
      />
    </div>
  );
}
